import { PATTERNS } from '../../constants/validations';
import { defaultValidator } from './defaultValidator';

export const isEmail = value =>
  defaultValidator(PATTERNS.HAS_ALPHABETICAL_CHARACTER, value);



// WEBPACK FOOTER //
// ./src/utils/validations/isEmail.js